<template>
    <div>
        <div class="legend-container">
            <div class="legend-item" :style="`background-color: ${item.bgc}; color: ${item.textColor}`" v-for="item in legendData" :key="item.id">
                {{item.title}}
            </div>
        </div>
    </div>
</template>

<script>
    import { getRoleColor } from '@/common/functions'
    export default {
        name: 'RoleColorsLegend',
        props: ['roles'],
        data: () => ({
        }),
        computed: {
            legendData () {
                return this.roles.map(roleId => {
                    const color = getRoleColor(roleId)
                    return {
                        id: roleId,
                        bgc: color.bgc,
                        textColor: color.text,
                        title: this.$store.getters.getRoleById(roleId).title
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .legend-container {
        display: flex;
        overflow: auto;
        flex-wrap: wrap;
        .legend-item {
            height: 30px;
            min-width: 100px;
            font-size: 12px;
            padding: 0 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
